// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  defaultauth: 'firebase',
  firebaseConfig: {
    apiKey: 'AIzaSyD-CpWJP3kzMne6bp0pm1BiIFUzXaYufYw',
    authDomain: 'joongshim-c14d8.firebaseapp.com',
    projectId: 'joongshim-c14d8',
    storageBucket: 'joongshim-c14d8.appspot.com',
    messagingSenderId: '29192064873',
    appId: '1:29192064873:web:78b2a6fa867be5aef4f7f8',
    measurementId: 'G-P1XQ2YX4P3',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
